import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class ConfigService {
    public assetBasePath: string = '/'; // default fallback

    constructor() {
        if (typeof window !== 'undefined' && (window as any).ASSET_BASE_PATH) {
            this.assetBasePath = (window as any).ASSET_BASE_PATH;
        }
    }

    getAssetPath(): string {
        return `${this.assetBasePath}`;
    }

    getBasePath(): string {
        const basePath = this.assetBasePath.split('/');
        basePath.splice(-2, 2);
        let newPath = basePath.join('/');
        return `${newPath}`;
    }
}
